import sortBy from 'lodash/sortBy'
import moment from 'moment'

import type Contract from 'modules/contracts/lib/Contract'
import type ContractVersion from 'modules/contracts/store/models/ContractVersion'

export const ContractSchedule = {
  expired: 'expired',
  ongoing: 'ongoing',
  upcoming: 'upcoming',
}

export const getContractVersionSchedule = (
  contractVersion: ContractVersion,
  sortedContractVersions: ContractVersion[]
) => {
  const now = moment()
  const referenceDate = contractVersion.effectiveOn
  if (referenceDate.isAfter(now)) return ContractSchedule.upcoming
  if (referenceDate.isBefore(now) && contractVersion.terminated) return ContractSchedule.expired
  /**
   * Contract versions may not have an end_date,
   * but we can say that a contract version expires when another version starts being effective
   */
  const contractIndex = sortedContractVersions.findIndex(
    (version) => version.id === contractVersion.id
  )
  const nextContractVersion = sortedContractVersions[contractIndex + 1]
  if (contractIndex == 0) {
    if (!nextContractVersion || nextContractVersion.effectiveOn.isAfter(now))
      return ContractSchedule.ongoing
    return ContractSchedule.expired
  }
  if (nextContractVersion?.effectiveOn.isBefore(now)) return ContractSchedule.expired

  return ContractSchedule.ongoing
}

export const hasOngoingOrUpcomingContract = (contracts: Contract[]): boolean => {
  const ongoingContract = contracts.find(
    (contract) => contract.isOngoing() || contract.isUpcoming()
  )
  return !!ongoingContract
}

export const hasOngoing = (contracts: Contract[]): boolean => {
  const ongoingContract = contracts.find((contract) => contract.isOngoing())
  return !!ongoingContract
}
export const sortContractVersions = (allContractVersions: ContractVersion[]) => {
  return sortBy(allContractVersions, (contractVersion) => contractVersion.effectiveOn)
}
